import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { formatNumber } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

import { QuotationService } from '@service/quotation.service';
import { CommonService } from '@service/common.service';

import { QuoteData } from '@model/quotation.model';
import { SelectedProduct } from '@model/product-detail.model';

import { StatusMode, TravelType, PackageTypeCatagory } from '@enum/quotation.enum';

@Component({
  selector: 'app-quote-summary',
  templateUrl: './quote-summary.component.html',
  styleUrls: ['./quote-summary.component.scss']
})
export class QuoteSummaryComponent implements OnInit, OnDestroy {
  @Input() isEditable: boolean = true;
  @Input() currentQuoteData: QuoteData;
  @Output() handleOnEdit: EventEmitter<any> = new EventEmitter<any>();

  quotation$: Observable<QuoteData>;
  productPrice$: Observable<string>;

  private onDestroy$: Subject<void> = new Subject();

  constructor(private quotationService: QuotationService, private commonService: CommonService) {}

  ngOnInit(): void {
    this.quotation$ = this.getQuotationData();
    this.productPrice$ = this.getProductPrice();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  getQuotationData(): Observable<QuoteData> {
    return this.quotationService.getQuoteData().pipe(takeUntil(this.onDestroy$));
  }

  getProductPrice(): Observable<string> {
    return this.quotationService.getSelectedProduct().pipe(
      map((product: SelectedProduct) => {
        if (product && product.product) {
          return this.calculatePrice(product.product.prodPrice);
        } else {
          return '-';
        }
      }),
      takeUntil(this.onDestroy$)
    );
  }

  calculatePrice(price: string): string {
    const productPrice: number = this.commonService.convertCurrencyToNumber(price);

    if (this.currentQuoteData && this.currentQuoteData.type.code === PackageTypeCatagory.INDIVIDUAL) {
      return formatNumber(productPrice * parseInt(this.currentQuoteData.numPeople.code, 10), 'en', '1.2');
    } else {
      return formatNumber(productPrice, 'en', '1.2');
    }
  }

  onEdit(): void {
    this.handleOnEdit.emit(StatusMode.EDIT);
  }

  isSigleTrip(tripType: string): boolean {
    return tripType === TravelType.SINGLE_TRIP;
  }

  isAnnualTrip(tripType: string): boolean {
    return tripType === TravelType.ANNUAL_TRIP;
  }
}
